module.exports = __webpack_public_path__ + "static/media/Lekstorp.89981c5e.jpg";